<template>
  <div id="app">
    <app-notification :title="message.title" :text="message.text" :css="message.css" :bar="message.bar" />
    <app-loader :title="loader.title" :visible="loader.visible" />
    <!-- app block screen -->
    <app-block-screen :visible="blockScreen.blockScreenActive" :user="$store.state.users" />
    <!-- router -->
    <template v-if="!blockScreen.blockScreenActive">
      <router-view />
    </template>
  </div>
</template>
<script>
import AppNotification from "@/components/AppNotification/AppNotification.vue";
import AppLoader from "@/components/AppLoader/AppLoader.vue";
import AppBlockScreen from "@/components/AppBlockScreen/AppBlockScreen.vue";

import { mapState } from "vuex";
export default {
  components: {
    AppNotification,
    AppLoader,
    AppBlockScreen
  },
  computed: {
    ...mapState(["users"]),
    ...mapState(["message", "loader", "blockScreen"])
  },
  mounted() {
    document.body.classList.add('vertical-collpsed');
    
  },
};
</script>